
import moment from "moment";
import { mapState, mapStores } from "pinia";
import { defineComponent } from "vue";
import { StationStats } from "~/api/models/station-stats.model";

import WidgetContentBase from '~/components/widgets/widget-content-base';
import { useDashboardStore } from "~/store/dashboard.store";

const fake: StationStats = {
    period: {
        since: moment().subtract(1, 'w').unix(),
        before: moment().unix()
    },
    data: {
        'CO2': {
            min: 450,
            min_date: moment().subtract(10, 'h').unix(),
            max: 1200,
            max_date: moment().subtract(23, 'h').unix(),
            mean: 842,
            distribution: {

            }
        }
    },
}

export default defineComponent({

    extends: WidgetContentBase,

    computed: {
        ...mapStores(useDashboardStore),
        ...mapState(useDashboardStore, ['currentStation', 'stats']),

        data(): StationStats {
            return this.fake ? fake : this.stats;
        },

        score(): 'A' |'B' |'C' |'D' |'E' | null {
            if(this.max > 1500) {
                return 'E';
            } else if(this.max > 1000) {
                return 'D';
            } else if(this.max > 800) {
                return 'C';
            } else if(this.max > 600) {
                return 'B';
            } else if(this.max > 0) {
                return 'A';
            } else {
                return null;
            }
        },

        max() {
            if(!this.data || !this.data?.data['CO2']) {
                return -1;
            }
            return this.data.data['CO2']?.max;
        },

        icon(): string {
            if(!this.score) {
                return '';
            }

            return require(`@/aero-score-${this.score.toLocaleLowerCase()}.png`).default;
        },

        range(): string {
            switch(this.score) {
                case 'A':
                return `${this.$t('dashboard.aero_score_widget.co2_level')} < 600 ppm`;
                case 'B':
                return `600 ppm < ${this.$t('dashboard.aero_score_widget.co2_level')} < 800 ppm`;
                case 'C':
                return `800 ppm < ${this.$t('dashboard.aero_score_widget.co2_level')} < 1000 ppm`;
                case 'D':
                return `1000 ppm < ${this.$t('dashboard.aero_score_widget.co2_level')} < 1500 ppm`;
                case 'E':
                    return `${this.$t('dashboard.aero_score_widget.co2_level')} > 1500 ppm`;
                default:
                    return '-'
            }
        },

        label(): string {
            switch(this.score) {
                case 'A':
                    return this.$t('dashboard.aero_score_widget.label_excellent');
                case 'B':
                return this.$t('dashboard.aero_score_widget.label_good');
                case 'C':
                return this.$t('dashboard.aero_score_widget.label_medium');
                case 'D':
                return this.$t('dashboard.aero_score_widget.label_poor');
                case 'E':
                return this.$t('dashboard.aero_score_widget.label_inadequate');
                default:
                    return '-'
            }
        }

    },
});

